import ReactDOMServer from 'react-dom/server'
import { createCanvas, loadImage } from 'canvas'
import moment from 'moment-timezone'

import QR from '../components/QR'

export const currentStatus = event => {
  const startMoment = moment(event.event_start_date).tz(moment.tz.guess())
  const endMoment = moment(event.event_end_date).tz(moment.tz.guess())
  if (endMoment.diff(moment()) < 0) {
    return 'event.status.completed'
  }
  if (startMoment.diff(moment()) < 0) {
    return 'event.status.inProgress'
  }
  return 'event.status.upcoming'
}

export const mobileDeepLink = event => {
  return `${window.location.origin}/events/${event.slug || event.id}`
}

// QR value volunteers scan to self check in/out. The token is secret:
// never render this URL as text, share it, or log it.
export const checkInDeepLink = event => {
  if (!event?.check_in_token) return mobileDeepLink(event)
  return `${mobileDeepLink(event)}?check_in_token=${event.check_in_token}`
}

export const removeHTMLTags = text => {
  const regex = /(<([^>]+)>)/gi
  return text.replace(regex, '')
}

// Owner or event admin (matches backend Event#power_user?)
export const isEventAdmin = (event, user) => {
  if (!user?.id || !event) return false
  if (event.user?.id === user.id) return true
  return !!event.admins?.some(a => a.id === user.id)
}

export const isEventTaskLeader = (event, user) => {
  if (!user?.id || !Array.isArray(event?.tasks)) return false
  return event.tasks.some(
    task =>
      Array.isArray(task?.task_leader_users) &&
      task.task_leader_users.some(u => u?.id === user.id),
  )
}

export const canManageVolunteers = (event, user) =>
  isEventAdmin(event, user) || isEventTaskLeader(event, user)

// useApi's put() catches non-2xx responses and returns
// { success: false, error }, so the backend's { error, code } body
// lives at response.error.response.data.
export const apiErrorCode = response => response?.error?.response?.data?.code

export const apiErrorMessage = response =>
  response?.error?.response?.data?.error

export const getTeam = event => {
  const admins = (event?.admins ?? []).map(a => ({ ...a }))
  const leaders = (event?.tasks ?? []).flatMap(t => t?.task_leader_users ?? [])
  return [...new Map([...admins, ...leaders].map(i => [i.id, i])).values()]
}

export const QRCodePNG = async ({ title, value, size }) => {
  // Renderizar el QR Code como un SVG
  const svgString = ReactDOMServer.renderToString(
    <QR title={title} value={value} size={size} svgOnly />,
  )
  // Crear un elemento canvas
  const canvas = createCanvas(size, size)
  const ctx = canvas.getContext('2d')

  // Convertir SVG a data URL
  const svgBlob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' })
  const url = URL.createObjectURL(svgBlob)

  // Cargar la imagen en el canvas
  const image = await loadImage(url)
  ctx.drawImage(image, 0, 0)

  // Convertir el canvas a PNG
  const pngDataUrl = canvas.toDataURL('image/png')

  return pngDataUrl
}

export default {
  currentStatus,
  mobileDeepLink,
  checkInDeepLink,
  removeHTMLTags,
  isEventAdmin,
  isEventTaskLeader,
  canManageVolunteers,
  apiErrorCode,
  apiErrorMessage,
  getTeam,
  QRCodePNG,
}
